import { render, staticRenderFns } from "./IconRss.vue?vue&type=template&id=30761fd8&scoped=true&"
import script from "./IconRss.vue?vue&type=script&lang=js&"
export * from "./IconRss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30761fd8",
  null
  
)

export default component.exports